import {
  type PortableTextTypeComponentOptions,
  toHTML,
} from '@portabletext/to-html'
import h from 'hyperscript'

import {
  type SanityComplexPortableText,
  type SanitySimplePortableText,
} from '@data/sanity/queries/types/content'
import { type SanityImageFragment } from '@data/sanity/queries/types/image'
import { getSanityImageUrl } from '@lib/image'

export const getPortableTextHtml = (
  portableText?: SanityComplexPortableText | SanitySimplePortableText,
) => {
  if (!portableText) {
    return ''
  }

  return toHTML(
    portableText.filter(({ _type }) => ['block', 'figure'].includes(_type)),
    {
      components: {
        types: {
          figure: ({
            value,
          }: PortableTextTypeComponentOptions<SanityImageFragment>) => {
            const imageUrl = getSanityImageUrl(value, {
              width: value.asset?.metadata?.dimensions?.width,
              height: value.asset?.metadata?.dimensions?.height,
              fitMax: true,
              autoFormat: true,
            })

            return h('img', {
              src: imageUrl,
              alt: value.alt,
            }).outerHTML
          },
        },
      },
    },
  )
}
